import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import { Footer as FooterUI } from "../../components/organisms/footer";
import { CopyRight } from "./optics";
import * as styles from "./styles.css";
const getProps = (data) => {
    const CopyRightInfoM = Fold.preview(CopyRight, data);
    const CopyRightInfo = pipe(CopyRightInfoM, Option.getOrElse(() => ""));
    return {
        CopyRightInfo,
    };
};
const Footer = ({ FooterLink, CopyRightInfo }) => (React.createElement("div", { className: styles.container },
    React.createElement(FooterUI, { FooterLink: FooterLink, CopyRightInfo: CopyRightInfo })));
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Footer);

